
import React,{useState} from 'react'
const ResumeForm = () => {
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [position1, setPosition1] = useState("");
    const [employer1, setEmployer1] = useState("");
    const [jobStart1, setJobStart1] = useState("");
    const [jobEnd1, setJobEnd1] = useState("");
    const [description1, setDescription1] = useState("");
    const [highSchool, setHighSchool] = useState("");
    const [diploma, setDiploma] = useState("");
    const [ged, setGed] = useState("");
    const [college1, setCollege1] = useState("");
    const [degree, setDegree] = useState("");
    const [educationStart1, setEducationStart1] = useState("");
    const [educationEnd1, setEducationEnd1] = useState("");
    const [schools, setSchools] = useState([]);
  

    var canvas = document.getElementById("canvas");
    var ctx = canvas.getContext("2d");
    
    // Set canvas size
    canvas.width = 1000;
    canvas.height = 1000;
    
    // Draw notebook paper
    ctx.fillStyle = "#f7f7f7";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    // Draw notebook lines
    ctx.strokeStyle = "#cccccc";
    ctx.beginPath();
    
    // Vertical lines
    for (var x = 0; x <= canvas.width; x += 30) {
      ctx.moveTo(x, 0);
      ctx.lineTo(x, canvas.height);
    }
    
    // Horizontal lines
    for (var y = 0; y <= canvas.height; y += 30) {
      ctx.moveTo(0, y);
      ctx.lineTo(canvas.width, y);
    }
    
    // Draw with mouse
    var mouse = {x: 0, y: 0};
    
    canvas.addEventListener('mousemove', function(e) {
      mouse.x = e.pageX - this.offsetLeft;
      mouse.y = e.pageY - this.offsetTop;
    }, false);
    
    // Pencil Settings
    ctx.lineWidth = 2;
    ctx.lineJoin = "round";
    ctx.lineCap = "round";
    ctx.strokeStyle = "black";
    
    canvas.addEventListener('mousedown', function(e) {
      ctx.beginPath();
      ctx.moveTo(mouse.x, mouse.y);
    
      canvas.addEventListener('mousemove', onPaint, false);
    }, false);
    
    canvas.addEventListener('mouseup', function() {
      canvas.removeEventListener('mousemove', onPaint, false);
    }, false);
    
    var onPaint = function() {
      ctx.lineTo(mouse.x, mouse.y);
      ctx.stroke();
    };
    
    ctx.stroke();
function addToPrompt(){
  // console.log(name,' Is the NAMEMMMMEE...')
  // let csv = 
}



    const handleSubmit = (e) => {
      e.preventDefault();

      alert("Your resume is ready to be made! Head back to the prompt and send your information in.");
    };
  
    return (<>
      <form onSubmit={handleSubmit}>
        
        
        <div className="csv-input-group">
        <label htmlFor='name' className='hover-underline'>Name:</label>
        <input
          type="text"
          value={name}
          className="ff"
          placeholder="First, Last"
          onChange={(e) => setName(e.target.value)}
        />
        <button type='button' className='button-light' onClick={(name) => {addToPrompt()}}>send it!</button>
        </div>


        <div className="csv-input-group">
        <label  htmlFor='phone' className='hover-underline'>Phone Number:</label>
        <input
          type="text"
          className="ff"
          placeholder="()___-____"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <button className='button-light'type='button'onClick={(phone) =>{addToPrompt()}}>send it!</button>

</div>



<div className="csv-input-group">
        <label  htmlFor='email' className='hover-underline'>Email:</label>
        <input
          type="text"
          className="ff"
          placeholder="active email adress"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button className='button-light' type='button'onClick={(email) => {addToPrompt()}}>send it!</button>
</div>


<div className="csv-input-group">
        <label htmlFor='position1' className='hover-underline'>Most Recent Position Title:</label>
        <input
          type="text"
          className="ff"
          placeholder="most recet title"
          value={position1}
          onChange={(e) => setPosition1(e.target.value)}
        />
        <button className='button-light'type='button'onClick={(position1)=> {addToPrompt()}}>send it!</button>

</div>


<div className="csv-input-group">
        <label  htmlFor='employer1' className='hover-underline'>Employer:</label>
        <input
          type="text"
          className="ff"
          placeholder="employer"
          value={employer1}
          onChange={(e) => setEmployer1(e.target.value)}
        />
        <button className='button-light'type='button'onClick={(employer1)=>{addToPrompt()}}>send it!</button>

</div>


<div className="csv-input-group">
        <label  htmlFor='jobstart1' className='hover-underline'>Job Start Date:</label>
        <input
          type="text"
          value={jobStart1}
          className="ff"
          placeholder="started date"
          onChange={(e) => setJobStart1(e.target.value)}
        />
        <button className='button-light'type='button'onClick={(jobStart1) => {addToPrompt()}}>send it!</button>

</div>

<div className="csv-input-group">
        <label  htmlFor='jobend1' className='hover-underline'>Job End Date:</label>
        <input
          type="text"
          value={jobEnd1}
          className="ff"
          placeholder="end date"
          onChange={(e) => setJobEnd1(e.target.value)}
       />
        <button className='button-light'type='button'onClick={(jobEnd1) => {addToPrompt()}}>send it!</button>

</div>


<div className="csv-input-group">
        <label  htmlFor='description1' className='hover-underline'>Job Description:</label>
        <input
          type="text"
          className="ff"
          placeholder="responsibilites"
          value={description1}
          onChange={(e) => setDescription1(e.target.value)}
        />
        <button className='button-light'type='button'onClick={(description1) => {addToPrompt()}}>send it!</button>

</div>

<div className="csv-input-group">
        <label  htmlFor='highschool' className='hover-underline'>High School:</label>
        <input
          type="text"
          value={highSchool}
          className="ff"
          placeholder="High School"
          onChange={(e) => setHighSchool(e.target.value)}
        />
        <button className='button-light'type='button'onClick={(highSchool)=> {addToPrompt()}}>send it!</button>

</div>

<div className="csv-input-group">
        <label  htmlFor='diploma' className='hover-underline'>Diploma? (y/n):</label>
        <input
          type="text"
          value={diploma}
          className="ff"
          placeholder="Y/N"
          onChange={(e) => setDiploma(e.target.value)}
        />
        <button className='button-light'type='button'onClick={(diploma) => {addToPrompt()}}>send it!</button>

</div>


<div className="csv-input-group">
        <label  htmlFor='ged' className='hover-underline'>GED:</label>
        <input
          type="text"
          value={ged}
          className="ff"
          placeholder="Y/N"
          onChange={(e) => setGed(e.target.value)}
        />
        <button className='button-light'type='button'onClick={(ged) => {addToPrompt()}}>send it!</button>

</div>


<div className="csv-input-group">
        <label  htmlFor='college1' className='hover-underline'>College/University Name:</label>
        <input
          type="text"
          value={college1}
          className="ff"
          placeholder="University name"
          onChange={(e) => setCollege1(e.target.value)}
        />
        <button className='button-light'type='button'onClick={(college1) => {addToPrompt()}}>send it!</button>

</div>


<div className="csv-input-group">
        <label  htmlFor='degree' className='hover-underline'>Degree:</label>
        <input
          type="text"
          className="ff"
          placeholder="Acievement or degree"
          value={degree}
          onChange={(e) => setDegree(e.target.value)}
        />
        <button className='button-light'type='button'onClick={(degree) => {addToPrompt()}}>send it!</button>

</div>

<div className="csv-input-group">
        <label  htmlFor='educationstart1' className='hover-underline'>Education Start Date:</label>
        <input
          type="text"
          className="ff"
          placeholder="College Start Date"
          value={educationStart1}
          onChange={(e) => setEducationStart1(e.target.value)}
        />
        <button className='button-light'type='button'onClick={(educationStart1) => {addToPrompt()}}>send it!</button>

</div>


<div className="csv-input-group">
        <label  htmlFor='educationend1' className='hover-underline'>Education End Date:</label>
        <input
          type="text"
          className="ff"
          placeholder="College End date"
          value={educationEnd1}
          onChange={(e) => setEducationEnd1(e.target.value)}
        />
        <button className='button-light'type='button'onClick={(educationEnd1)=>{addToPrompt()}}>send it!</button>

</div>

<div className="csv-input-group">
        <label  htmlFor='schools' className='hover-underline'>Schools:</label>
        <input
          type="text"
          className="ff"
          placeholder="other school names"
          value={schools}
          onChange={(e) => setSchools(e.target.value)}
      
      />
        <button className='button-light'type='button'onClick={(schools) => {addToPrompt()}}>send it!</button>

</div>




        <input type="submit" value="Submit" />





      </form>



<div className='drawing-area'>
<canvas className='notepad' width='1000' height='1000' id='canvas'></canvas>
</div>
</>
    );
  
  
  };
  
  export default ResumeForm;